export type PaginationProps = {
  readonly currentPage: number;
  readonly setCurrentPage: (page: number) => void;
  readonly maxPage: number;
};

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  setCurrentPage,
  maxPage,
}: PaginationProps) => {
  if (maxPage <= 1) {
    return null;
  }

  return (
    <nav aria-label="navigation w-100">
      <ul className="pagination justify-content-center">
        <li className="page-item">
          <a
            className="page-link"
            href="#"
            title="Zur ersten Seite"
            aria-label="Previous"
            onClick={() => {
              setCurrentPage(0);
            }}
          >
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li className="page-item">
          <a
            className="page-link"
            href="#"
            aria-label="Previous"
            onClick={() => {
              if (currentPage > 0) setCurrentPage(currentPage - 1);
            }}
          >
            <span aria-hidden="true">&lsaquo;</span>
          </a>
        </li>
        {currentPage > 0 && (
          <li className="page-item">
            <a
              className="page-link"
              href="#"
              title={`(${currentPage}/${maxPage})`}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              {currentPage}
            </a>
          </li>
        )}
        <li className="page-item">
          <a
            className="page-link active"
            href="#"
            title={`(${currentPage + 1}/${maxPage})`}
          >
            {currentPage + 1}
          </a>
        </li>
        {currentPage + 1 < maxPage && (
          <li className="page-item">
            <a
              className="page-link"
              href="#"
              title={`(${currentPage + 2}/${maxPage})`}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              {currentPage + 2}
            </a>
          </li>
        )}
        <li className="page-item">
          <a
            className="page-link"
            href="#"
            aria-label="Next"
            onClick={() => {
              if (currentPage + 1 < maxPage) setCurrentPage(currentPage + 1);
            }}
          >
            <span aria-hidden="true">&rsaquo;</span>
          </a>
        </li>
        <li className="page-item">
          <a
            className="page-link"
            href="#"
            title="Zur letzten Seite"
            aria-label="Next"
            onClick={() => {
              setCurrentPage(maxPage - 1);
            }}
          >
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  );
};
